import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  StyledPagination,
  StyledWrapperCarousel,
  StyledCarousel,
  StyledList,
  StyledPage
} from './style';

const ITEMS_PER_PAGE = 8;
let timer = null;

class PaginatorAnimated extends Component {
  constructor() {
    super();

    this.state = {
      pages: 0,
      moveX: 0,
      active: 0,
      activePage: 0
    };
  }

  componentDidMount() {
    this.getWidthWrapper();
    this.getDataList();
    window.addEventListener('resize', this.getWidthWrapper);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getWidthWrapper);
  }

  // elements to paginate
  getDataList = () => {
    const { data } = this.props;
    const totalItems = data.length;

    // Number of pages
    const pages = Math.ceil(totalItems / ITEMS_PER_PAGE);

    this.setState({
      pages
    });
  };

  // render of the pagination
  getPages = pages => {
    const items = [];

    for (let i = 0; i < pages; i += 1) {
      items.push(
        <StyledPage
          className={i === 0 && 'active'}
          key={i}
          onClick={this.paginate}
        />
      );
    }

    return <StyledList id="pagination">{items}</StyledList>;
  };

  // width of the container. Distance to paginate
  getWidthWrapper = () => {
    const wrapper = document.getElementById('wrapperCarousel');

    const widthWrapper = wrapper.clientWidth;
    this.setState({
      moveX: widthWrapper
    });
  };

  // get active item and aply styles
  paginate = e => {
    let activePage;
    let i = 0;
    const item = document.querySelector('#pagination .active');
    const wrapper = document.getElementById('wrapperCarousel');

    item.classList.remove('active');
    e.target.classList.add('active');
    const totalItems = document.querySelectorAll('#pagination li');
    totalItems.forEach(item => {
      if (item.classList.value.indexOf('active') !== -1) {
        activePage = i;
      }
      i += 1;
    });

    // mobile - tablet: scroll
    if (window.innerWidth < 1280) {
      this.paginateMobile(activePage);
    } else {
      // desktop: animate
      this.setState(
        {
          active: activePage,
          activePage
        },
        () => {
          wrapper.scrollLeft = 0;
        }
      );
    }
  };

  paginateMobile = active => {
    const wrapper = document.getElementById('wrapperCarousel');

    const widthWrapper = wrapper.clientWidth;
    this.setState(
      {
        moveX: widthWrapper
      },
      () => {
        wrapper.scrollLeft = active * widthWrapper;
      }
    );
  };

  paginateScroll = () => {
    const { activePage } = this.state;

    const items = document.querySelectorAll('#pagination li');
    const item = document.querySelector('#pagination .active');

    item.classList.remove('active');

    items[activePage].classList.add('active');
  };

  scrollPage = e => {
    this.getWidthWrapper();
    const { moveX } = this.state;
    const scroll = e.target.scrollLeft;
    const active = Math.round(scroll / moveX);

    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      this.setState(
        {
          activePage: active
        },
        () => {
          this.paginateScroll();
        }
      );
    }, 150);
  };

  render() {
    const { children, className } = this.props;
    const { pages } = this.state;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        paginate: this.paginate,
        getDataList: this.getDataList,
        getWidthWrapper: this.getWidthWrapper
      })
    );

    return (
      <StyledPagination className={className}>
        <StyledWrapperCarousel id="wrapperCarousel" onScroll={this.scrollPage}>
          <StyledCarousel moveX={this.state.moveX} active={this.state.active}>
            {childrenWithProps}
          </StyledCarousel>
        </StyledWrapperCarousel>
        {pages > 1 && <nav>{this.getPages(pages)}</nav>}
      </StyledPagination>
    );
  }
}

PaginatorAnimated.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default PaginatorAnimated;
